import columns from '../../../react-table/helpers/columns';
import TableDefinitions from '../../../../common/TableDefinitions';

export function getDailyRouteLeadingCountReport(rowInfo) {
  return rowInfo && rowInfo.row ? {
    path: '/edi-rfid-audit-request-report',
    tableId: TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT.id,
    text: 'View Report',
  } : {};
}

export default (data) => {
  const {
    DateColumn,
    DateTimeColumn,
    NumberColumn,
    TextColumn,
    NavigationColumn,
    EditButtonColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new NumberColumn('Id', 'executionId').withShow(false),
        new TextColumn('Audit Filename', 'auditFilename'),
        new DateTimeColumn('Run Date', 'runDate'),
        new DateColumn('Reporting Start Date', 'reportingStartDate'),
        new DateColumn('Reporting End Date', 'reportingEndDate'),
        new TextColumn('Status', 'status'),
        new NavigationColumn(new EditButtonColumn('View Report', 'executionId'), getDailyRouteLeadingCountReport),
      ],
    },
  ];
};
